import { MenuItem } from '../types';

export const menuItems: MenuItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'LayoutDashboard',
    href: '/',
    role_access: ['admin', 'superadmin', 'teknisyen', 'calisan']
  },
  {
    id: 'arac_gerec',
    label: 'Araç Gereç',
    icon: 'Settings',
    role_access: ['admin', 'superadmin', 'teknisyen'],
    children: [
      {
        id: 'companies',
        label: 'Şirketler',
        icon: 'Building2',
        href: '/companies',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'locations',
        label: 'Lokasyonlar',
        icon: 'MapPin',
        href: '/locations',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'suppliers',
        label: 'Tedarikçiler',
        icon: 'Truck',
        href: '/suppliers',
        role_access: ['admin', 'superadmin', 'teknisyen']
      },
      {
        id: 'equipment',
        label: 'Ekipmanlar',
        icon: 'Package',
        href: '/equipment',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'consumables',
        label: 'Sarf Malzemeler',
        icon: 'ShoppingCart',
        href: '/consumables',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'documents',
        label: 'Evraklar',
        icon: 'FileText',
        href: '/documents',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'maintenance_contracts',
        label: 'Bakım Anlaşmaları',
        icon: 'FileCheck',
        href: '/maintenance-contracts',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'damage_theft',
        label: 'Hasar & Çalınma',
        icon: 'AlertTriangle',
        href: '/damage-theft',
        role_access: ['admin', 'superadmin']
      }
    ]
  },
  {
    id: 'orders',
    label: 'Siparişler',
    icon: 'ShoppingCart',
    href: '/orders',
    role_access: ['admin', 'superadmin']
  },
  {
    id: 'capex',
    label: 'CAPEX',
    icon: 'DollarSign',
    href: '/capex',
    role_access: ['admin', 'superadmin']
  },
  {
    id: 'printers',
    label: 'Yazıcılar',
    icon: 'Printer',
    href: '/printers',
    role_access: ['admin', 'superadmin']
  },
  {
    id: 'technical_service',
    label: 'Teknik Servis',
    icon: 'Wrench',
    href: '/technical-service',
    role_access: ['admin', 'superadmin', 'teknisyen']
  },
  {
    id: 'it_equipment',
    label: 'IT Ekipmanları',
    icon: 'Laptop',
    role_access: ['admin', 'superadmin'],
    children: [
      {
        id: 'computers',
        label: 'Bilgisayarlar',
        icon: 'Monitor',
        href: '/computers',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'computer-brands',
        label: 'Markalar',
        icon: 'Package',
        href: '/computer-brands',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'computer-models',
        label: 'Modeller',
        icon: 'Package',
        href: '/computer-models',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'mobile_phones',
        label: 'Cep Telefonları',
        icon: 'Smartphone',
        href: '/mobile-phones',
        role_access: ['admin', 'superadmin']
      }
    ]
  },
  {
    id: 'servers',
    label: 'Sunucular',
    icon: 'Server',
    role_access: ['admin', 'superadmin'],
    children: [
      {
        id: 'physical_servers',
        label: 'Fiziksel Sunucular',
        icon: 'Server',
        href: '/physical-servers',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'virtual_servers',
        label: 'Sanal Sunucular',
        icon: 'Cloud',
        href: '/virtual-servers',
        role_access: ['admin', 'superadmin']
      }
    ]
  },
  {
    id: 'industrial',
    label: 'Industrial',
    icon: 'Settings',
    role_access: ['admin', 'superadmin', 'teknisyen'],
    children: [
      {
        id: 'iot',
        label: 'IoT Cihazları',
        icon: 'Wifi',
        href: '/iot-devices',
        role_access: ['admin', 'superadmin', 'teknisyen']
      },
      {
        id: 'scales',
        label: 'Akıllı Teraziler',
        icon: 'Scale',
        href: '/scales',
        role_access: ['admin', 'superadmin', 'teknisyen']
      },
      {
        id: 'radios',
        label: 'Telsizler',
        icon: 'Radio',
        href: '/radios',
        role_access: ['admin', 'superadmin', 'teknisyen']
      },
      {
        id: 'handheld_terminals',
        label: 'El Terminalleri',
        icon: 'Smartphone',
        href: '/handheld-terminals',
        role_access: ['admin', 'teknisyen','superadmin']
      }
    ]
  },
  {
    id: 'network',
    label: 'Ağ',
    icon: 'Network',
    role_access: ['admin', 'superadmin', 'teknisyen'],
    children: [
      {
        id: 'network_switches',
        label: 'Network Switch',
        icon: 'Network',
        href: '/switches',
        role_access: ['admin', 'superadmin', 'teknisyen']
      },
      {
        id: 'cabinets',
        label: 'IT Kabinetleri',
        icon: 'Shield',
        href: '/cabinets',
        role_access: ['admin', 'superadmin', 'teknisyen']
      },
      {
        id: 'circuits',
        label: 'Devreler',
        icon: 'Wifi',
        href: '/circuits',
        role_access: ['admin', 'superadmin', 'teknisyen']
      }
    ]
  },
  {
    id: 'storage',
    label: 'Depolama Birimleri',
    icon: 'Database',
    href: '/storage-units',
    role_access: ['admin', 'superadmin']
  },

  {
    id: 'meetings',
    label: 'Toplantılar',
    icon: 'Calendar',
    href: '/meetings',
    role_access: ['admin', 'superadmin']
  },
  {
    id: 'assignment_forms',
    label: 'Zimmet İşlemleri',
    icon: 'FileText',
    role_access: ['admin', 'superadmin'],
    children: [
      {
        id: 'assignment_forms_main',
        label: 'Zimmet Formları',
        icon: 'FileText',
        href: '/assignment-forms',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'assignment_logs',
        label: 'Zimmetleme İşlem Logları',
        icon: 'Activity',
        href: '/assignment-logs',
        role_access: ['superadmin']
      }
    ]
  },
  {
    id: 'settings',
    label: 'Ayarlar',
    icon: 'Settings',
    role_access: ['admin', 'superadmin'],
    children: [
      {
        id: 'assignment_definitions',
        label: 'Zimmet Tanımları',
        icon: 'FileText',
        href: '/assignment-definitions',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'system_settings',
        label: 'Sistem Ayarları',
        icon: 'Settings',
        href: '/system-settings',
        role_access: ['superadmin']
      },
      {
        id: 'users',
        label: 'Kullanıcılar',
        icon: 'Users',
        href: '/users',
        role_access: ['admin', 'superadmin']
      },
      {
        id: 'activities',
        label: 'Kullanıcı Aktiviteleri',
        icon: 'Activity',
        href: '/user-activity',
        role_access: ['superadmin']
      },
      {
        id: 'announcements',
        label: 'Duyurular',
        icon: 'Bell',
        href: '/announcements',
        role_access: ['superadmin']
      },
      {
        id: 'menu-management',
        label: 'Menü Yönetimi',
        icon: 'Shield',
        href: '/menu-management',
        role_access: ['superadmin']
      }
    ]
  },
  {
    id: 'security_cameras',
    label: 'Nvr & Kamera',
    icon: 'FileText',
    role_access: ['admin', 'superadmin', 'teknisyen'],
    children: [
      {
        id: 'cameras',
        label: 'Kamera',
        icon: 'TrendingUp',
        href: '/cameras',
        role_access: ['admin', 'superadmin', 'teknisyen']
      },
      {
        id: 'camera-faults',
        label: 'Kamera Arızaları',
        icon: 'Cable',
        href: '/camera-faults',
        role_access: ['admin', 'superadmin', 'teknisyen']
      },
      {
        id: 'nvrs',
        label: 'Nvr',
        icon: 'Cable',
        href: '/nvrs',
        role_access: ['admin', 'superadmin', 'teknisyen']
      }
    ]
  },
  {
    id: 'profile',
    label: 'Profil',
    icon: 'User',
    href: '/profile',
    role_access: ['admin', 'superadmin', 'teknisyen', 'calisan']
  }
];